import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTE_CONTABILIDAD } from '../constants/constant.model';
import { ApiService } from './api.service';
import { ROUTE_HERRAMIENTAS } from '../constants/constant.model';

@Injectable({
  providedIn: 'root'
})
export class RegistroComprasService {

  constructor(private apiService: ApiService) { }

  insertar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra);
    return this.apiService.executePostJson(data).pipe();
  }

  modificar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra);
    return this.apiService.executePutJson(data).pipe();
  }

  anular(tipo: number, docume: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/anular/${tipo}/${docume}`);
    return this.apiService.executePutJson(null).pipe();
  }

  obtener(tipo: number, docume: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra);
    return this.apiService.execGetQueryJson(`/${tipo}/${docume}`).pipe();
  }

  obtenerpredet(tipo: number, docume: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/cuentas-predeterminadas`);
    return this.apiService.execGetQueryJson(`/${tipo}/${docume}`).pipe();
  }

  contabilizar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/contabilizar`);
    return this.apiService.executePutJson(data).pipe();
  }
  obtenerFull(tipo: any,docume:any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/con-asiento/${tipo}/${docume}`);
    return this.apiService.execGetJson();
  }

  descontabilizar(tipo: number, docume: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/descontabilizar/${tipo}/${docume}`);
    return this.apiService.executePutJson(null).pipe();
  }

  contabilizarCalcular(data: any): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/contabilizar/calcular`);
    return this.apiService.executePutJson(data).pipe();
  }

  importarAsientoContable(parameters: any, usua: any, periodo: any, mes: any): Observable<any> {
    let formData: FormData = new FormData()
    let nombres: string='';
  
    for (let i = 0; i < parameters.file.length; i++) {
      nombres += parameters.file[i].name+",";
      formData.append("files", parameters.file[i], parameters.file[i].name)
    }
 
    formData.append('ruc', parameters.ruc);
    formData.append('razonc', parameters.razonc);
    formData.append('codsuc', parameters.codsuc);
    formData.append('nombrearchivo', nombres);
    
    this.apiService.setUrlPathApi(ROUTE_HERRAMIENTAS.importacionXML);
    return this.apiService.execGetQueryJsonObjectPDF(`formatoxml?usua=${usua}&periodo=${periodo}&mes=${mes}`, formData).pipe();

  }

  documentosPorRelacionar(tipdoc: number, codsuc: number, codcli: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/buscar/documentos-por-relacionar?`);
    return this.apiService.execGetQueryJson(`tipdoc=${tipdoc}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }
  
}
